import React from 'react';
import { Modal, Button, Row } from 'antd';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';

const clientId = '1077122119';
const redirectUri =
  'https://console.arashivision.com/api/weibo/oauth/callback?client=pro%26callback=https://tools.insta360.com/live/weibo';
const authUrl = `https://api.weibo.com/oauth2/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=all`;

@inject('app', 'weibo')
@observer
class Auth extends React.Component {
  componentDidMount() {
    const { weibo } = this.props;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const accessToken = params.get('access_token');

    if (accessToken) {
      setTimeout(() => {
        weibo.setToken(accessToken);
        this.setState({
          visible: false
        });
      }, 1000);
    }
  }

  render() {
    const { langs, isMobile } = this.props.app;
    const { accessToken, clearToken } = this.props.weibo;

    return (
      <div>
        <Modal
          title={langs['live_auth_title']}
          visible={accessToken?false:true}
          closable={false}
          footer={null}
        >
          <p>
            {langs['live_auth_t1']}, <a href={authUrl}>{langs['live_auth_t2']}</a>
          </p>

          <div style={{ textAlign: 'right' }}>
            <Link to="/live">
              <Button type={'primary'}>{langs['live_auth_back']}</Button>
            </Link>
          </div>
        </Modal>

        {accessToken&&isMobile?(
          <div style={{ marginTop: '48px', textAlign: 'center' }}><a onClick={clearToken}>{langs['live_fb_create_user_logout']}</a></div>
        ):null}
      </div>
    );
  }
}

export default Auth;


// WEBPACK FOOTER //
// ./src/views/live/weibo/components/auth.js